// extracted by mini-css-extract-plugin
export default {"container":"EmptyList_container__S+Dw2","containerImg":"EmptyList_containerImg__m3ULp"};